import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import gotruckhub from "../assets/img/gotruckhub.png";
import truckhubio from "../assets/img/truckhubio.png";
import PEIcorp from "../assets/img/PEIcorp.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import healthlead from "../assets/img/healthlead.png";
import roboticpt from "../assets/img/roboticpt.png";
import buytesmart from "../assets/img/buytesmart.png";
import 'animate.css'; 
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Go Truck Hub CRM",
      description: "UI/UX Development",
      imgUrl: gotruckhub,
    },
    {
      title: "Health Lead CRM",
      description: "Front-End Development",
      imgUrl: healthlead,
    },
    {
      title: "Robotic PT",
      description: "Web Development",
      imgUrl: roboticpt,
    },
    {
      title: "Truck Hub",
      description: "Web Development",
      imgUrl: truckhubio,
    },
    {
      title: "BuyTESmart",
      description: "e-Commerce & Web Development",
      imgUrl: buytesmart,
    },
    {
      title: "Perry Ellis International",
      description: "e-Commerce & Web Development",
      imgUrl: PEIcorp,
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p><b>Some of my previous work on display, also paying homage to all the knowledge gained working on these prior endeavors.</b></p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="section">
                      <p>Some of my previous work</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
